import PropTypes from 'prop-types';
import React from 'react';
import { ButtonGroup, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../shared/components/Button';

const LOCALES_PATH = 'influencers.pages.campaign.apply_side_pane.facebook_connect.';

const InstagramSkipConnection = React.memo(
  ({
    onRequestClose,
    nextStep,
    prevStep,
  }) => {
    const { t } = useTranslation();

    return <div>
      <h3 className='mb-2'>
        {t(`${LOCALES_PATH}submit_application`)}
      </h3>

      <h5 className='mb-4'>
        {t(`${LOCALES_PATH}ready_to_submit`)}
      </h5>

      <hr className='my-6' />
      <Row className='justify-content-end'>
        <Col className="col-auto">
          <ButtonGroup className="non-adaptable">
            <Button
              variant="secondary"
              type="button"
              onClick={prevStep}>
              {t('influencers.common.back')}
            </Button>
            <Button
              variant='primary'
              type='button'
              onClick={() => nextStep({ connectFacebook: true })}
            >
              {t('influencers.common.finish')}
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    </div>;
  }
);

InstagramSkipConnection.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
};
export default InstagramSkipConnection;